import { CvExportsButton } from "PFApp/components/cv_exports_button";
import { Icon } from "PFComponents/icon";
import { Tabs } from "PFComponents/tabs";
import { useRoleName } from "PFCore/helpers/activities";
import PropTypes from "prop-types";
import { useRef } from "react";
import { useTranslation } from "react-i18next";
import { Link, useLocation } from "react-router";

import css from "./compare_header.module.scss";

const CompareHeader = ({ task, tabActiveId, changeTab, comparableProfiles }) => {
  const { t } = useTranslation("activities");
  const { t: tTranslation } = useTranslation();
  const getRoleName = useRoleName();
  const location = useLocation();
  const TABS = [
    { id: "details", title: t("compare.compareDetails") },
    { id: "availability", title: t("compare.compareAvailabity") }
  ];

  const prevPath = useRef(location.state?.prevPath);
  return (
    <div className={css.root}>
      <div className={css.header}>
        <Link className={css.back} to={prevPath.current || `/activities/${task.id}/shortlist`}>
          <Icon name="chevron-left" size="xxs" />
          {t("compare.exitCompare")}
        </Link>
        <CvExportsButton
          profileIds={comparableProfiles.map(({ profile }) => profile.id)}
          activityId={task.id}
          text={tTranslation("exportText")}
          icon={undefined}
          kind="primary"
        />
      </div>

      <div className={css.row}>
        <div className={css.tabs}>
          <Tabs onChange={changeTab} tabs={TABS} activeTab={tabActiveId} />
        </div>
        {task && task.name && <h1 className={css.name}>{getRoleName(task)}</h1>}
      </div>
    </div>
  );
};

CompareHeader.propTypes = {
  task: PropTypes.object.isRequired,
  tabActiveId: PropTypes.oneOf(["details", "availability"]).isRequired,
  changeTab: PropTypes.func.isRequired,
  comparableProfiles: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number,
      profile: PropTypes.shape({
        id: PropTypes.number
      }),
      applicableCustomValues: PropTypes.arrayOf(
        PropTypes.shape({
          requiredExperience: PropTypes.number,
          experience: PropTypes.number,
          text: PropTypes.string,
          importance: PropTypes.number
        })
      )
    })
  ).isRequired
};

export default CompareHeader;
